import { planFragment } from './plan-fragment';
import { subscriptionFragment } from './subscription-fragment';

export const availableUtilityDataQuery = `
  query availableUtilityData ($availableUtilityProviderInput: AvailableUtilityProviderInput!, $utilitySubscriptionsInput: UtilitySubscriptionsInput!) {
    availableUtilityProviders(input: $availableUtilityProviderInput) {
      utilityMarkets {
        enabled,
        kind,
        availablePlans {
          recommended,
          recommendedReason,
          plan {
            ...${planFragment.name}
          }
        }
      }
      utilityProviders {
        businessPhone,
        enabled,
        id,
        kind,
        localPhone,
        logo,
        matchLevel,
        name,
        website
      }
      utilityProvidersEdited
    }

    utilitySubscriptions(input: $utilitySubscriptionsInput) {
      electric {
        ...${subscriptionFragment.name}
      }

      gas {
        ...${subscriptionFragment.name}
      }
    }
  }
  ${planFragment.fragment}
  ${subscriptionFragment.fragment}
`;
